<template>
  <div class="content">
    <div class="row" v-for="(invitation, index) in invitations" :key="invitation.unitId">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-4">
            <ArtistSelect
              :currentIndex="index"
              @unitChangeEvent="getArtistInfo"
              :selectedUnitId="invitation.unitId"
              :show-title="false"
              :show-all-units="true"
              :show-members="false"
              :initial-unit-id="invitation.unitId"
            />
          </div>
          <div class="col-sm-6">
            <base-input class="date-picker" placeholder="">
              <el-date-picker type="datetimerange" start-placeholder="시작일시" end-placeholder="종료일시" v-model="invitation.eventPeriod" />
            </base-input>
          </div>
          <div class="col-sm-3">
            <base-input placeholder="필터명" v-model="invitation.ko">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <div class="col-sm-3">
            <base-input placeholder="필터명(영어)" v-model="invitation.en">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <div class="col-sm-3">
            <base-input placeholder="필터명(일본어)" v-model="invitation.ja">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>

          <div class="col-sm-2">
            <base-button class="btn-danger col-md-12" @click="removeRow(index)" type="success">-</base-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="row">
        <div class="col-sm-12">
          <base-button class="update-button" @click.prevent="addRow" type="confirm">추가</base-button>
          <base-button class="update-button" @click.prevent="setInvitationInfo" type="success">저장</base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BaseInput } from "@/components/index";
import swal from "sweetalert2";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";

export default {
  components: {
    ArtistSelect,
    BaseInput,
  },
  async created() {
    await this.getInvitationInfo();
  },
  data() {
    return {
      invitations: [],
    };
  },

  methods: {
    async getArtistInfo(param) {
      this.invitations[param.currentIndex].unitId = param.unitId;
    },
    addRow() {
      this.invitations.push({ id: new Date().toTimeString(), unitId: null, eventPeriod: null });
    },
    removeRow(index) {
      this.invitations.splice(index, 1);
    },
    async setInvitationInfo() {
      for (const invitation of this.invitations) {
        if (!invitation.eventPeriod) {
          window.Toast.error("시간을 입력해주세요");
          return;
        }
      }

      const param = { invitations: this.invitations };
      swal
        .fire({
          title: "필터등록",
          text: "",
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "등록",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            return this.$axios.put("/common/config", { key: "INVITATION", value: JSON.stringify(param) }).then((res) => {
              window.Toast.success(`필터 정보가 등록되었습니다`);
            });
          }
        });
    },
    async getInvitationInfo() {
      const res = await this.$axios.get(`/common/config?key=INVITATION`);
      const data = JSON.parse(res.data.data);
      this.invitations = data.invitations;
      // this.invitations = [
      //   { unitId: null, eventPeriod: null },
      //   { unitId: 20, eventPeriod: null },
      //   { unitId: 1, eventPeriod: [] },
      // ];
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
